import * as type from "./questionTypes";
import { teamNameInput } from "./questionContentUniversal";
//import {coursePayment} from "./questionContentUniversal";

import lincolnImage from '../../images/reflectingPool/locations/lincoln.jpg'
//mix and match images
import reflectingPoolLincoln from '../../images/reflectingPool/courseSelectionPreviews/reflectingPoolLincoln.jpg'
import reflectingLincolnStatue from '../../images/reflectingPool/courseSelectionPreviews/reflectingLincolnStatue.jpg'
import reflectingThreeStatues from '../../images/reflectingPool/courseSelectionPreviews/reflectingThreeStatues.jpg'
import reflectingPoolWWII from '../../images/reflectingPool/courseSelectionPreviews/reflectingPoolWWII.jpg'



const lincoln = {
  name: 'Lincoln Memorial',
  img: lincolnImage,
};

// note on regex: make sure to use lowercase as in the question check, we are converting to lowercase
const getToLincoln = {
  location: lincoln,
  type: type.newLocation,
  image1: null,
  content1: 'It won\'t cost money to get into this place, but a $5 bill could help you find it!',
  captionContent: "Tap 'I'm here' when you are at the steps leading up to this place",
  //hint: 'Just think about it',
  answer: {
    image1: lincoln.img,
    content1: 'You made it! The Lincoln memorial is depicted on both the $5 bill and the penny.'
  }

};


const blah = {
  displayName: "1+1",
  location: lincoln,
  type: type.freeTextQuestion,
  content1: 'Another test question',
  boldContent: 'What is 1 + 1',
  hint: 'Read the question',
  answer: {
    answer: new RegExp("(2|two)"),
    content1: "Of course, its two!",
  },
};
const boop = {
  displayName: "Identify memorials",
  location: lincoln,
  type: type.mixAndMatch,
  //image1: Fido,
  content1: 'There are many special places on the National Mall. Match the names to the picture!',
  boldContent: 'Match the names to the picture',
  hint: 'Read the question',
  specialContent: {
    initialCards: ['WWII Memorial', 'Lincoln Memorial', 'Vietnam Memorial', 'Lincoln Statue'],
    initialImages: [reflectingPoolLincoln, reflectingLincolnStatue, reflectingThreeStatues, reflectingPoolWWII],
  },
  answer: {
    answer: ['Lincoln Memorial', 'Lincoln Statue', 'Vietnam Memorial', 'WWII Memorial'],
    image1: null,
    content1: "Answer will go here.",
  },
};
const beep = {
  displayName: "Fingers",
  location: lincoln,
  type: type.multipleChoice,
  content1: 'Many people have hands.',
  boldContent: 'How many fingers are on a normal hand?',
  hint: 'Look at your own hand',
  specialContent: {
    initialCards: ['Three', 'Six', 'Five', 'None!'],
  },
  answer: {
    answer: 'five',
    image1: null,
    content1: "Answer will go here.",
  },
};

export const testCourseContent = {
  //getToLincoln, 
  //blah, 
  //boop,
  beep, 
  teamNameInput};